module.exports = __webpack_public_path__ + "img/logo.f826ef57.png";